import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AdminState {
  importData: unknown[];
  importInProgress: boolean;
  importResult: unknown | null;
  importErrors: string | null;
}

const initialState: AdminState = {
  importData: [],
  importInProgress: false,
  importResult: null,
  importErrors: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    importStarted: (state) => {
      state.importInProgress = true;
      state.importErrors = null;
    },
    importSuccess: (state, action: PayloadAction<unknown>) => {
      state.importInProgress = false;
      state.importResult = action.payload;
      state.importErrors = null;
    },
    importFailure: (state, action: PayloadAction<string>) => {
      state.importInProgress = false;
      state.importErrors = action.payload;
      state.importResult = null;
    },
    clearImportData: (state) => {
      state.importData = [];
      state.importResult = null;
      state.importErrors = null;
    },
  },
});

export const { importStarted, importSuccess, importFailure, clearImportData } = adminSlice.actions;
export default adminSlice.reducer;
